"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportType = void 0;
var TransportType;
(function (TransportType) {
    TransportType["GRPC"] = "GRPC";
    TransportType["GRAPHQL"] = "GRAPHQL";
    TransportType["HTTP"] = "HTTP";
})(TransportType = exports.TransportType || (exports.TransportType = {}));
